import { HardHat, FileCheck, Building2, Ruler, Cpu, Layers, CheckCircle, Monitor, ShoppingCart, Award, Users2, ShieldAlert } from 'lucide-react';

export const educationModules = [
  {
    slug: 'dasar-dasar-k3-konstruksi',
    title: 'Dasar-Dasar K3 Konstruksi',
    description: 'Panduan lengkap mengenai standar keamanan di area proyek sesuai regulasi terbaru.',
    icon: HardHat,
    color: 'bg-orange-500/10 text-orange-500',
    category: 'Sertifikasi',
    content: `
      <h2>Pentingnya K3 dalam Konstruksi</h2>
      <p>Kesehatan dan Keselamatan Kerja (K3) Konstruksi adalah segala kegiatan untuk menjamin dan melindungi keselamatan dan kesehatan tenaga kerja melalui upaya pencegahan kecelakaan kerja dan penyakit akibat kerja pada pekerjaan konstruksi.</p>
      
      <h3>Prinsip Dasar K3</h3>
      <ul>
        <li><strong>Identifikasi Bahaya:</strong> Mengenali potensi sumber kecelakaan di lokasi proyek.</li>
        <li><strong>Penilaian Risiko:</strong> Mengukur seberapa besar dampak dari bahaya yang ada.</li>
        <li><strong>Pengendalian Risiko:</strong> Langkah nyata untuk menghilangkan atau meminimalisir bahaya.</li>
      </ul>

      <h3>Alat Pelindung Diri (APD) Wajib</h3>
      <p>Setiap personil yang memasuki area proyek wajib menggunakan:</p>
      <ol>
        <li>Helm Keselamatan (Safety Helmet)</li>
        <li>Sepatu Safety (Safety Shoes)</li>
        <li>Rompi Reflektor (Safety Vest)</li>
        <li>Kaca Mata Pelindung (jika diperlukan)</li>
      </ol>
    `
  },
  {
    slug: 'manajemen-kontrak-jasa-konstruksi',
    title: 'Manajemen Kontrak Jasa Konstruksi',
    description: 'Memahami aspek hukum dan administrasi dalam kontrak kerja konstruksi.',
    icon: FileCheck,
    color: 'bg-blue-500/10 text-blue-500',
    category: 'Administrasi',
    content: `
      <h2>Memahami Kontrak Konstruksi</h2>
      <p>Kontrak Kerja Konstruksi adalah keseluruhan dokumen yang mengatur hubungan hukum antara pengguna jasa dan penyedia jasa dalam penyelenggaraan pekerjaan konstruksi.</p>

      <h3>Jenis-jenis Kontrak</h3>
      <ul>
        <li><strong>Lump Sum:</strong> Pembayaran dilakukan berdasarkan harga tetap untuk seluruh lingkup pekerjaan.</li>
        <li><strong>Harga Satuan (Unit Price):</strong> Pembayaran berdasarkan volume pekerjaan aktual yang terlaksana.</li>
        <li><strong>Gabungan Lump Sum dan Harga Satuan:</strong> Kombinasi keduanya untuk item pekerjaan tertentu.</li>
      </ul>

      <h3>Aspek Penting dalam Kontrak</h3>
      <p>Beberapa hal kritis yang harus diperhatikan dalam administrasi kontrak:</p>
      <ul>
        <li>Lingkup Pekerjaan (Scope of Work)</li>
        <li>Jangka Waktu Pelaksanaan (Time for Completion)</li>
        <li>Sistem Pembayaran dan Retensi</li>
        <li>Penyelesaian Perselisihan (Dispute Resolution)</li>
      </ul>
    `
  },
  {
    slug: 'standar-sni-struktur-beton',
    title: 'Standar SNI Struktur Beton',
    description: 'Bedah standar teknis perhitungan struktur beton bertulang untuk bangunan gedung.',
    icon: Building2,
    color: 'bg-emerald-500/10 text-emerald-500',
    category: 'Teknis',
    content: `
      <h2>Standar Nasional Indonesia (SNI) Beton</h2>
      <p>SNI 2847:2019 merupakan standar terbaru yang mengatur persyaratan beton struktural untuk bangunan gedung di Indonesia.</p>

      <h3>Komponen Beton Bertulang</h3>
      <p>Beton bertulang memanfaatkan kekuatan tekan beton dan kekuatan tarik baja tulangan secara bersamaan.</p>

      <h3>Persyaratan Material</h3>
      <ul>
        <li><strong>Semen:</strong> Harus memenuhi standar SNI semen yang berlaku.</li>
        <li><strong>Agregat:</strong> Harus bersih dari material organik dan lumpur berlebih.</li>
        <li><strong>Air:</strong> Tidak boleh mengandung zat yang merusak baja tulangan atau beton.</li>
        <li><strong>Tulangan:</strong> Menggunakan Baja Tulangan Beton (BjTS) sesuai spesifikasi desain.</li>
      </ul>
    `
  },
  {
    slug: 'estimasi-biaya-dan-penjadwalan',
    title: 'Estimasi Biaya dan Penjadwalan',
    description: 'Teknik menyusun RAB dan Kurva-S yang akurat untuk efisiensi proyek.',
    icon: Ruler,
    color: 'bg-purple-500/10 text-purple-500',
    category: 'Manajemen',
    content: `
      <h2>Penyusunan RAB dan Jadwal Proyek</h2>
      <p>Manajemen biaya dan waktu adalah kunci keberhasilan proyek konstruksi agar selesai tepat mutu, tepat waktu, dan tepat biaya.</p>

      <h3>Tahapan Penyusunan RAB</h3>
      <ol>
        <li>Perhitungan Volume Pekerjaan (Take-off Bolt)</li>
        <li>Analisis Harga Satuan Pekerjaan (AHSP)</li>
        <li>Rekapitulasi Biaya</li>
      </ol>

      <h3>Metode Penjadwalan</h3>
      <p>Dua metode yang paling sering digunakan di industri konstruksi Indonesia:</p>
      <ul>
        <li><strong>Bar Chart & Kurva-S:</strong> Grafik untuk memantau progres akumulatif proyek.</li>
        <li><strong>CPM (Critical Path Method):</strong> Mengidentifikasi jalur kritis pekerjaan yang tidak boleh terlambat.</li>
      </ul>
    `
  },
  {
    slug: 'teknologi-bim-konstruksi',
    title: 'Teknologi BIM dalam Konstruksi',
    description: 'Penerapan Digital Construction dan Pemodelan 3D Informasi Bangunan.',
    icon: Cpu,
    color: 'bg-cyan-500/10 text-cyan-500',
    category: 'Teknologi',
    content: `
      <h2>Apa itu BIM?</h2>
      <p>Building Information Modeling (BIM) adalah suatu proses kolaboratif yang berbasis model 3D cerdas yang memberikan wawasan kepada para profesional arsitektur, teknik, dan konstruksi (AEC).</p>

      <h3>Manfaat Implementasi BIM</h3>
      <ul>
        <li><strong>Clash Detection:</strong> Menemukan benturan antar elemen struktur/MEP sebelum konstruksi dimulai.</li>
        <li><strong>Efisiensi Material:</strong> Perhitungan volume (QTO) yang lebih akurat dan otomatis.</li>
        <li><strong>Visualisasi Real-time:</strong> Memudahkan koordinasi antar stakeholder proyek.</li>
      </ul>

      <h3>Level of Development (LOD)</h3>
      <p>Terdapat beberapa tingkatan kedetailan model BIM dari LOD 100 (konsep) hingga LOD 500 (as-built/operation).</p>
    `
  },
  {
    slug: 'metode-kerja-shop-drawing',
    title: 'Metode Kerja & Shop Drawing',
    description: 'Alur pembuatan detail teknis lapangan dan instruksi kerja yang efektif.',
    icon: Layers,
    color: 'bg-rose-500/10 text-rose-500',
    category: 'Teknis',
    content: `
      <h2>Pentingnya Shop Drawing</h2>
      <p>Shop Drawing adalah gambar detail pelaksanaan yang dibuat berdasarkan Gambar Rencana (For Construction Drawing) untuk mempermudah pekerjaan di lapangan.</p>

      <h3>Tahapan Persetujuan</h3>
      <ol>
        <li>Pembuatan draf oleh Draftman/Engineer Kontraktor.</li>
        <li>Review internal oleh Site Manager.</li>
        <li>Pengajuan persetujuan (Submittal) kepada Konsultan Pengawas/MK.</li>
        <li>Distribusi gambar "Approved for Construction" ke tim lapangan.</li>
      </ol>

      <h3>Isi Metode Kerja</h3>
      <p>Metode kerja yang baik harus mencakup: Urutan kerja, Alat yang digunakan, Tenaga kerja, Material, serta Analisis Risiko (K3).</p>
    `
  },
  {
    slug: 'audit-mutu-quality-assurance',
    title: 'Audit Mutu & Quality Assurance',
    description: 'Sistem penjaminan kualitas hasil pekerjaan sesuai spesifikasi teknis.',
    icon: CheckCircle,
    color: 'bg-yellow-500/10 text-yellow-500',
    category: 'Mutu',
    content: `
      <h2>Quality Assurance vs Quality Control</h2>
      <p>QA berfokus pada pencegahan kesalahan (proses), sedangkan QC berfokus pada pendeteksian kesalahan (hasil akhir).</p>

      <h3>Instrumen Kendali Mutu</h3>
      <ul>
        <li><strong>Checklist Inspeksi:</strong> Lembar rutin untuk memverifikasi kesiapan setiap tahapan pekerjaan.</li>
        <li><strong>Rencana Mutu Kontrak (RMK):</strong> Dokumen induk penjaminan mutu proyek.</li>
        <li><strong>Tes Laboratorium:</strong> Pengujian material secara berkala (tes slump beton, kuat tekan, tarik besi).</li>
      </ul>

      <h3>Tindakan Korektif</h3>
      <p>Jika ditemukan deviasi mutu, harus segera dilakukan perbaikan sesuai instruksi pengawas dan dicatat dalam Non-Conformance Report (NCR).</p>
    `
  },
  {
    slug: 'sistem-pengadaan-elektronik-spse',
    title: 'Sistem Pengadaan Elektronik (SPSE)',
    description: 'Panduan tata cara mengikuti lelang proyek pemerintah secara online.',
    icon: Monitor,
    color: 'bg-indigo-500/10 text-indigo-500',
    category: 'Administrasi',
    content: `
      <h2>Mengenal Layanan Pengadaan Secara Elektronik (LPSE)</h2>
      <p>LPSE mengelola Sistem Pengadaan Secara Elektronik (SPSE) untuk meningkatkan transparansi dan efisiensi pengadaan barang/jasa pemerintah.</p>

      <h3>Alur Tender Elektronik</h3>
      <ol>
        <li>Pengumuman Lelang/Tender.</li>
        <li>Pendaftaran dan Pengunduhan Dokumen Pemilihan.</li>
        <li>Pemberian Penjelasan (Aanwijzing).</li>
        <li>Penyampaian Dokumen Penawaran.</li>
        <li>Evaluasi Penawaran dan Pembuktian Kualifikasi.</li>
        <li>Penetapan dan Pengumuman Pemenang.</li>
      </ol>

      <h3>Dokumen Persyaratan Umum</h3>
      <p>Pastikan SBU (Sertifikat Badan Usaha), NIB (Nomor Induk Berusaha), dan dokumen legalitas lainnya tersimpan dengan rapi di Sistem Informasi Kinerja Penyedia (SIKaP).</p>
    `
  },
  {
    slug: 'sistem-ekatalog-government',
    title: 'Sistem E-Katalog Pemerintah',
    description: 'Panduan E-Purchasing untuk pengadaan langsung melalui katalog elektronik LKPP.',
    icon: ShoppingCart,
    color: 'bg-orange-600/10 text-orange-600',
    category: 'Administrasi',
    content: `
      <h2>Apa itu E-Katalog LKPP?</h2>
      <p>E-Katalog adalah sistem informasi elektronik yang memuat daftar, jenis, spesifikasi teknis, dan harga Barang/Jasa tertentu dari berbagai penyedia.</p>

      <h3>Manfaat E-Katalog untuk Konstruksi</h3>
      <ul>
        <li><strong>Transparansi Harga:</strong> Harga sudah tertera dan dapat dibandingkan secara terbuka.</li>
        <li><strong>Kecepatan Proses:</strong> Memangkas waktu tender konvensional menjadi pembelian langsung (E-Purchasing).</li>
        <li><strong>Akuntabilitas:</strong> Semua rekam jejak transaksi tercatat secara digital dalam sistem LKPP.</li>
      </ul>

      <h3>Kategori Produk Konstruksi</h3>
      <p>Saat ini tersedia berbagai kategori mulai dari Pekerjaan Jalan, Jembatan, Bangunan Gedung, hingga Jasa Konsultansi Konstruksi di dalam Katalog Lokal, Sektoral, maupun Nasional.</p>
    `
  },
  {
    slug: 'sikap-lkpp-penyedia',
    title: 'SIKaP LKPP untuk Penyedia',
    description: 'Optimalisasi Profil Penyedia di Sistem Informasi Kinerja Penyedia.',
    icon: Award,
    color: 'bg-sky-500/10 text-sky-500',
    category: 'Sertifikasi',
    content: `
      <h2>Mengenal SIKaP (Sistem Informasi Kinerja Penyedia)</h2>
      <p>SIKaP merupakan subsistem dari SPSE yang digunakan untuk mengelola data kualifikasi dan riwayat kinerja penyedia barang/jasa.</p>

      <h3>Data yang Perlu Diunggah</h3>
      <ul>
        <li><strong>Izin Usaha:</strong> NIB, SBU, SIUJK.</li>
        <li><strong>Perpajakan:</strong> NPWP, SPT Tahunan terakhir.</li>
        <li><strong>Peralatan:</strong> Daftar alat berat/pendukung milik sendiri atau sewa.</li>
        <li><strong>Tenaga Ahli:</strong> Data SKK (Sertifikat Kompetensi Kerja) personil perusahaan.</li>
        <li><strong>Pengalaman:</strong> Riwayat kontrak pekerjaan yang telah diselesaikan.</li>
      </ul>

      <h3>Pentingnya Update Data SIKaP</h3>
      <p>Data di SIKaP digunakan untuk proses <strong>Tender Cepat</strong> dan pembuktian kualifikasi otomatis. Jika data tidak update, penyedia berisiko gugur dalam evaluasi teknis/administrasi.</p>
    `
  },
  {
    slug: 'etik-pengadaan-barang-jasa',
    title: 'Etika Pengadaan Barang & Jasa',
    description: 'Memahami prinsip dan kode etik dalam pengadaan pemerintah.',
    icon: ShieldAlert,
    color: 'bg-red-500/10 text-red-500',
    category: 'Regulasi',
    content: `
      <h2>Prinsip Pengadaan (Perpres 16/2018 jo 12/2021)</h2>
      <p>Sesuai regulasi terbaru, pengadaan harus dilakukan berdasarkan prinsip:</p>
      <ol>
        <li>Efisien</li>
        <li>Efektif</li>
        <li>Transparan</li>
        <li>Terbuka</li>
        <li>Bersaing</li>
        <li>Adil (Tidak Diskriminatif)</li>
        <li>Akuntabel</li>
      </ol>

      <h3>Larangan dalam Pengadaan</h3>
      <p>Setiap stakeholder dilarang melakukan:</p>
      <ul>
        <li>Indikasi KKN (Korupsi, Kolusi, Nepotisme).</li>
        <li>Penyalahgunaan Wewenang.</li>
        <li>Persaingan Usaha Tidak Sehat (Arisan Tender).</li>
      </ul>
    `
  }
];
